export const NS_PaymentOptions = {
  content: `<p><span class="sub-heading-underline">Premium Payment Options</span> Changing the premium payment mode may increase the overall cost of the policy. You may pay premiums once a year (annually) or twelve times a year (monthly). You may pay premiums only by pre-authorized electronic transfer. If you pay annual premiums by installments, there will be an additional charge. The additional charge is shown in dollars and as annual percentage rates in the table below.</p>
        <table id="payment-options" cellpadding="4" cellspacing="0">
            <tr>
                <td>Premium Frequency</td>
                <td>Premium Payment (Including Installment Payment Charge)</td>
                <td>Number of Payments Per Year</td>
                <td>Total Premium Per Year</td>
                <td>Additional Charge (In Dollars)</td>
                <td>Additional Charge (As the Annual Percentage Rate or APR)</td>
            </tr>
            <tr>
                <td>Annual</td>
                <td>{{AnnualPremium}}</td>
                <td>1</td>
                <td>{{AnnualPremium}}</td>
                <td>$0.00</td>
                <td>-</td>
            </tr>
            <tr>
                <td>Monthly</td>
                <td>{{MonthlyPremium}}</td>
                <td>12</td>
                <td>{{TotalMonthlyPremium}}</td>
                <td>{{AdditionalChargeMonthly}}</td>
                <td>{{RATE}}</td>
            </tr>
        </table>`,
  supplementalContent: `<p class="break-before"><span class="sub-heading-underline">Premium Payment Options</span> Changing the premium payment mode may increase the overall cost of the policy. You may pay premiums once a year (annually) or twelve times a year (monthly). You may pay premiums only by pre-authorized electronic transfer. If you pay annual premiums by installments, there will be an additional charge. The additional charge is shown in dollars and as annual percentage rates in the table below.</p>
    <table id="payment-options" cellpadding="4" cellspacing="0">
        <tr>
            <td>Premium Frequency</td>
            <td>Premium Payment (Including Installment Payment Charge)</td>
            <td>Number of Payments Per Year</td>
            <td>Total Premium Per Year</td>
            <td>Additional Charge (In Dollars)</td>
            <td>Additional Charge (As the Annual Percentage Rate or APR)</td>
        </tr>
        <tr>
            <td>Annual</td>
            <td>{{AnnualPremium}}</td>
            <td>1</td>
            <td>{{AnnualPremium}}</td>
            <td>$0.00</td>
            <td>-</td>
        </tr>
        <tr>
            <td>Monthly</td>
            <td>{{MonthlyPremium}}</td>
            <td>12</td>
            <td>{{TotalMonthlyPremium}}</td>
            <td>{{AdditionalChargeMonthly}}</td>
            <td>{{RATE}}</td>
        </tr>
    </table>`,
  style: `
        #payment-options { width:100%; max-width: 520px; border:4px solid #000; border-collapse: collapse; text-align: center; font: 11px 'Times New Roman'; margin-top:5px}
        #payment-options td { width: 16.6667%; border:1px solid #000 }
        .break-before {page-break-before:always}
    `,
};
